module.exports = __webpack_public_path__ + "static/media/spinner.c7a5690c.png";